import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-rc.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-rc.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CreateApplicationLocationRcConstants } from "./create-application-location-rc.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { MapService } from "../../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { AlertType } from "../../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { debounceTime } from "rxjs";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { RecipientSelectService } from "../../../../../shared/components/recipient-select/shared/service/recipient-select.service";
import { PopUpComponent } from "../../../../../shared/components/pop-up/pop-up.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CreateApplicationDetailsRcConstants } from "../create-application-details.rc/create-application-details-rc.constants";
import Query from "@arcgis/core/rest/support/Query";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
import { take, takeUntil } from "rxjs/operators";
import { SimulationUtils } from "src/app/shared/utils/simulation-utils";
let CreateApplicationLocationRcComponent = class CreateApplicationLocationRcComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    recipientSelectService;
    appController;
    mapService;
    modalService;
    requestStatusService;
    changeDetectorRefs;
    activeTabIndex;
    propertiesForm;
    descriptionLabel1 = CreateApplicationLocationRcConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationRcConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationRcConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = CreateApplicationLocationRcConstants.DESCRIPTION_LABEL_4;
    validationMessages = CreateApplicationLocationRcConstants.VALIDATION_MESSAGES;
    erfNoControl = CreateApplicationLocationRcConstants.ERF_NO_CONTROL;
    subdivisionControl = CreateApplicationLocationRcConstants.SUBDIVISION_CONTROL;
    allotmentControl = CreateApplicationLocationRcConstants.ALLOTMENT_CONTROL;
    farmNoControl = CreateApplicationLocationRcConstants.FARM_NO_CONTROL;
    sgCodeControl = CreateApplicationLocationRcConstants.SG_CODE_CONTROL;
    addressControl = CreateApplicationLocationRcConstants.ADDRESS_CONTROL;
    erfNoTextPlaceHolder = CreateApplicationLocationRcConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = CreateApplicationLocationRcConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = CreateApplicationLocationRcConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = CreateApplicationLocationRcConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = CreateApplicationLocationRcConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateApplicationLocationRcConstants.ADDRESS_TEXT_PLACEHOLDER;
    removePropertyLabel = CreateApplicationLocationRcConstants.REMOVE_PROPERTY_LABEL;
    managingAgentDisableFilterBy = true;
    managingAgentDisableAdd = false;
    managingAgentDisableEditing = false;
    managingAgentGroups = [];
    managingAgentLabel = "Managing agent";
    selectedPropertySubscription;
    mapComponent;
    zones = [];
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    titleDeedNumberControl = CreateApplicationLocationRcConstants.TITLE_DEED_NUMBER_CONTROL;
    zoningControl = CreateApplicationLocationRcConstants.ZONING_CONTROL;
    sectionalTitleSchemeNameControl = CreateApplicationLocationRcConstants.SECTIONAL_TITLE_SCHEME_NAME_CONTROL;
    sectionalTitleSchemeNumberControl = CreateApplicationLocationRcConstants.SECTIONAL_TITLE_SCHEME_NUMBER_CONTROL;
    sectionalTitleSchemeUnitControl = CreateApplicationLocationRcConstants.SECTIONAL_TITLE_SCHEME_UNIT_CONTROL;
    extentControl = CreateApplicationLocationRcConstants.EXTENT_CONTROL;
    purchasePriceControl = CreateApplicationLocationRcConstants.PURCHASE_PRICE_CONTROL;
    dateOfSaleControl = CreateApplicationLocationRcConstants.DATE_OF_SALE_CONTROL;
    electricityAccountNumberControl = CreateApplicationLocationRcConstants.ELECTRICITY_ACCOUNT_NUMBER_CONTROL;
    waterAccountNumberControl = CreateApplicationLocationRcConstants.WATER_ACCOUNT_NUMBER_CONTROL;
    refuseAccountNumberControl = CreateApplicationLocationRcConstants.REFUSE_ACCOUNT_NUMBER_CONTROL;
    managingAgentControl = CreateApplicationLocationRcConstants.MANAGING_AGENT_CONTROL;
    titleDeedNumberLabel = CreateApplicationLocationRcConstants.TITLE_DEED_NUMBER_LABEL;
    zoningLabel = CreateApplicationLocationRcConstants.ZONING_LABEL;
    sectionalTitleSchemeNameLabel = CreateApplicationLocationRcConstants.SECTIONAL_TITLE_SCHEME_NAME_LABEL;
    sectionalTitleSchemeNumberLabel = CreateApplicationLocationRcConstants.SECTIONAL_TITLE_SCHEME_NUMBER_LABEL;
    sectionalTitleSchemeUnitLabel = CreateApplicationLocationRcConstants.SECTIONAL_TITLE_SCHEME_UNIT_LABEL;
    extentLabel = CreateApplicationLocationRcConstants.EXTENT_LABEL;
    purchasePriceLabel = CreateApplicationLocationRcConstants.PURCHASE_PRICE_LABEL;
    dateOfSaleLabel = CreateApplicationLocationRcConstants.DATE_OF_SALE_LABEL;
    electricityAccountNumberLabel = CreateApplicationLocationRcConstants.ELECTRICITY_ACCOUNT_NUMBER_LABEL;
    waterAccountNumberLabel = CreateApplicationLocationRcConstants.WATER_ACCOUNT_NUMBER_LABEL;
    refuseAccountNumberLabel = CreateApplicationLocationRcConstants.REFUSE_ACCOUNT_NUMBER_LABEL;
    modalOptions = CreateApplicationLocationRcConstants.MODAL_OPTION;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    constructor(createApplicationService, aflaModuleStrategyService, recipientSelectService, appController, mapService, modalService, requestStatusService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientSelectService = recipientSelectService;
        this.appController = appController;
        this.mapService = mapService;
        this.modalService = modalService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        if (this.appController.moduleSimulateMode) {
            let defaults = SimulationUtils.simulate_Create_Application();
            this.zones = defaults.zoneOptions;
            this.managingAgentGroups = this.recipientSelectService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientFilterGroupObjects);
        }
        else {
            if (this.aflaModuleStrategyService.lookups.has("zoning")) {
                this.zones = this.aflaModuleStrategyService.lookups.get("zoning");
            }
            else {
                this.getLookups();
            }
            this.getMetadata();
        }
        this.initForm();
        this.subscribeToProperty();
        if (this.createApplicationService.propertyData) {
            this.loadExistingProperty(this.createApplicationService.propertyData);
            this.createApplicationService.propertyData = null;
        }
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    mapLoaded() {
        this.syncMapGeometries();
        this.changeDetectorRefs.detectChanges();
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
    }
    loadMetadata(stepMeta) {
        this.managingAgentGroups = stepMeta.managingAgentGroup;
        if (this.managingAgentGroups[0].hasOwnProperty("requiredFields") && this.managingAgentGroups[0].requiredFields !== null) {
            this.managingAgentGroups = this.recipientSelectService.checkStepMetaRecipientGroups(this.managingAgentGroups);
        }
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    updateRequiredFields(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        const subdivisionControl = propertyControl.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.setValue("");
            subdivisionControl.setValue("");
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") ||
            (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.setValue("");
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        this.getProperties().removeAt(propertyIndex);
        this.mapComponent.clearGraphics("Rates certificate graphics");
        this.changeDetectorRefs.detectChanges();
    }
    hasControlValidator(control) {
        if (control.validator) {
            const validator = control.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
    }
    setNumberToDecimal(control, event) {
        // sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get("propertiesForm");
    }
    loadExistingProperty(property) {
        this.setPropertyData(property, property.geometry);
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyData");
        const sgCode = this.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgcode");
        let found = false;
        this.getProperties().controls.forEach(item => {
            const check = item.get("sgCode").value;
            if (check === sgCode) {
                found = true;
                this.appController.showMessage(CreateApplicationLocationRcConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("GetPropertyData");
            }
        });
        if (!found) {
            const newProperty = new FormGroup({
                erfNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfno"), [Validators.required]),
                subdivision: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PtnNum", "ptnnum"), [Validators.required]),
                allotment: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment"), [Validators.required]),
                farmNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmno"), [Validators.required]),
                sgCode: new FormControl(sgCode, [Validators.required]),
                address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                titleDeedNumber: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "TitleDeed", "titledeed"), [Validators.required]),
                zoning: new FormControl(null, [Validators.required]),
                sectionalTitleSchemeName: new FormControl(null),
                sectionalTitleSchemeNumber: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "SgDiagramNo", "sgdiagramno")),
                sectionalTitleSchemeUnit: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "UnitNumber", "unitnumber")),
                extent: new FormControl(null, [Validators.required]),
                purchasePrice: new FormControl(null, [Validators.required]),
                dateOfSale: new FormControl(null, [Validators.required]),
                electricityAccountNumber: new FormControl(null),
                waterAccountNumber: new FormControl(null),
                refuseAccountNumber: new FormControl(null),
                geometry: new FormControl(geometry),
                centroid: new FormControl(null, [Validators.required]),
                managingAgent: new FormControl(null, [Validators.required])
            });
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            this.getTrueCentroidSubscription = this.createApplicationService.getTrueCentroid(url, formData)
                .pipe(takeUntil(this._destroy$), take(1)).subscribe({
                next: (trueCentroidResponse) => {
                    this.setPropertyTrueCentroidData(newProperty, trueCentroidResponse);
                    this.setPropertyZoning(newProperty, sgCode);
                    this.changeDetectorRefs.detectChanges();
                    this.syncMapGeometries();
                    this.requestStatusService.removeBusySpinner("GetPropertyData");
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyData");
                    this.appController.handleServerErrorMessage(CreateApplicationLocationRcConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                }
            });
        }
    }
    setPropertyTrueCentroidData(newFormGroup, trueCentroidResponse) {
        const propertiesArray = this.getProperties();
        newFormGroup.get("centroid").setValue(trueCentroidResponse.results[0].value);
        propertiesArray.push(newFormGroup);
        this.activeTabIndex = propertiesArray.length - 1;
        this.updateRequiredFields(this.activeTabIndex);
        this.changeDetectorRefs.detectChanges();
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Rates certificate graphics", true);
        }
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                this.checkIfPropertyIsAlreadyLoaded(property);
            }
        });
    }
    checkIfPropertyIsAlreadyLoaded(property) {
        const title = "Replace property";
        const contentMessage = "An application can only have 1 property. Do you want to replace the current property?";
        const propertyControl = this.getProperties();
        if (propertyControl && propertyControl.length > 0) {
            const dialogRef = this.modalService.open(PopUpComponent, this.modalOptions);
            dialogRef.componentInstance.title = title;
            dialogRef.componentInstance.contentMessage = contentMessage;
            dialogRef.componentInstance.data = true;
            dialogRef.result.then((replaceData) => {
                if (replaceData) {
                    this.getProperties().clear();
                    this.mapComponent.clearGraphics("Rates certificate graphics");
                    this.setPropertyData(property.attributes, property.geometry);
                }
            });
        }
        else {
            this.setPropertyData(property.attributes, property.geometry);
        }
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.appController.selectedModuleID}`,
        };
        this.createApplicationService.getLookupsObservable(params).pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDetailsRcConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const zones = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name?.toLowerCase() === "zoning") {
                    zones.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("zoning", zones);
        this.zones = zones;
        this.changeDetectorRefs.detectChanges();
    }
    setPropertyZoning(newFormGroup, sgCode) {
        const zoningControl = newFormGroup.get(this.zoningControl);
        const zoningLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === "Property zone");
        if (zoningLayerObj !== undefined && zoningLayerObj !== null) {
            const zoningLayer = zoningLayerObj.layer;
            const zoningQuery = new Query();
            zoningQuery.where = `SgCode = '${sgCode}' or sgcode = '${sgCode}'`;
            zoningQuery.returnGeometry = false;
            zoningQuery.outFields = ["*"];
            zoningLayer.queryFeatures(zoningQuery).then((zoneFeatureSet) => {
                if (zoneFeatureSet.features.length > 0) {
                    zoneFeatureSet.features.forEach(item => {
                        const zone = this.propertyDataAlternateColumnName(item.attributes, "Zoning", "zoning"); // zone from the property layer
                        if (zone !== undefined && zone != null) {
                            let foundZone;
                            this.zones.forEach(zoneItem => {
                                if (zoneItem.value === zone) {
                                    foundZone = zoneItem;
                                }
                            });
                            if (zoningControl) {
                                zoningControl.setValue(zone);
                            }
                        }
                        else {
                            this.appController.showMessage(CreateApplicationLocationRcConstants.ZONING_NOT_FOUND.replace("{0}", zone), AlertType.Error);
                            const params = {
                                moduleId: this.createApplicationService.moduleID, lookupType: "Zoning", lookupList: [zone]
                            };
                            this.createApplicationService.sendMissingLookupsEmail(params).subscribe();
                        }
                    });
                }
                else {
                    this.appController.showMessage(CreateApplicationLocationRcConstants.INVALID_ZONING_ATTRIBUTE, AlertType.Error);
                }
            });
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: RecipientSelectService },
        { type: AppControllerService },
        { type: MapService },
        { type: NgbModal },
        { type: RequestStatusService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationRcComponent = __decorate([
    Component({
        selector: "app-create-application-location-rc",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], CreateApplicationLocationRcComponent);
export { CreateApplicationLocationRcComponent };
